import '../../public/css/media/_sign_in.scss';
import React from 'react';
import { Link, } from 'react-router';
import FacebookLogin from './FacebookLogin';
import ReactDOM from 'react-dom';
import MobileHeaderSidenav from './Layout/Header/MobileHeader'
import Footer from './Layout/Footer/Footer';
import { extensionDetect } from '../utils/utils';
import logo from '../assets/images/brand-logo.svg';
import { handleAppUrl } from '../utils/urls';
/* eslint-disable */
const appConfig = require('webpack-config-loader!../app-config.js');
const fbAppId = appConfig.fbAppId;
const extensionId = appConfig.extensionId;
/* eslint-enable */

const createReactClass = require('create-react-class');
const SignIn = createReactClass({

  getInitialState() {
    return {
      isFormSubmitted: false,
      resetPassword: false,
      rememberMe: false,
      trackPackage: false,
      noOtherError: true,
      email: null,
      password: null,
    }
  },
  componentWillMount() {
    window.location.href = `${handleAppUrl()}/sign-in`;
    if (localStorage.resetPassword) { this.setState({ resetPassword: true, }); }
    localStorage.removeItem('resetPassword');
    localStorage.trackPackage ?
      this.setState({ trackPackage: true, })
      : this.setState({ trackPackage: false, });

    /*if (localStorage.rememberMe === "true") {
      this.setState({ email: localStorage.email, password: localStorage.password, })
    }
    else {
      this.setState({ email: null, password: null, });
      localStorage.removeItem("email");
      localStorage.removeItem("password");
    }*/
    this.props.getCopyrightYear();
    document.title = "Sign in | ShippingCart";

    /*SC-695 Add script to remove email and password keys in localstorage */
    localStorage.removeItem("email");
    localStorage.removeItem("password");
    localStorage.removeItem('checkoutModalShowed');

    const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    const isMac = navigator.userAgent.toLowerCase().indexOf('mac') > -1;
    if(isChrome){
      if(isMac) {
        localStorage.setItem("cartExtensionModalShowed", true)
      } else {
        extensionDetect(extensionId)
      }
    }else{
      localStorage.setItem("cartExtensionModalShowed", true)
    }
    if (this.props.location.query && this.props.location.query.rewardPage){
      localStorage.setItem('rewardPage', true);
    }
  },
  componentWillUnmount() {
    this.props.resetAccounts();
    this.clrErrorMsgs();
    localStorage.removeItem("trackPackage");
  },
  responseFacebook(response) {
    const token = response.accessToken;
    this.props.FacebookSignedIn(token);
  },
  handleSubmit(e) {
    e.preventDefault();
    this.clrErrorMsgs();
    const email = this.refs.email.value;
    const password = this.refs.password.value;

    if (email.length === 0 || password.length === 0) {
      this.handleSubmitFieldValidation(email, password);
    } else {
      this.props.signin(email, password);
      this.setState({ isFormSubmitted: true, });
      localStorage.setItem("rememberMe", this.state.rememberMe);
    }
  },
  handleSubmitFieldValidation(email, password) {

    if(email.length === 0) {
      this.refs.errors_email.className = "input-error";
      this.refs.errors_email.innerHTML = "The email field is required";
      this.refs.errors_email.parentElement.className = "control has-error";
    }

    if(password.length === 0) {
      this.refs.errors_password.className = "input-error";
      this.refs.errors_password.innerHTML = "The password field is required";
      this.refs.errors_password.parentElement.className = "control has-error";
    }
  },
  handleClick() {
    if (this.refs.show_password.checked) {
      this.refs.password.type = 'text';
    } else {
      this.refs.password.type = 'password';
    }
  },
  componentDidMount() {
    window.scrollTo(0, 0)

    // <!-- Lightning Bolt Begins -->
    const lbscript = document.createElement("script");
    lbscript.type = "text/javascript";
    lbscript.src = "/js/lightningbolt.js";
    lbscript.async = true;
    document.body.appendChild(lbscript);

    const lbscript1 = document.createElement("script");
    lbscript1.type = "text/javascript";
    lbscript1.setAttribute('id', 'lightning_bolt');
    lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
    lbscript1.async = true;
    document.body.appendChild(lbscript1);
    // <!-- Lightning Bolt Ends -->
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.login.fetched && localStorage.trackPackage) {
      localStorage.setItem("trackPackage2", true);
    }
    /*if (nextProps.login.fetched && localStorage.rememberMe === "true") {
      localStorage.setItem("email", this.refs.email.value);
      localStorage.setItem("password", this.refs.password.value);
    }*/
    if (!nextProps.login.error) {
      this.clrErrorMsgs();
    }
  },
  componentDidUpdate() {
    if (this.state.isFormSubmitted) {
      window.scrollTo(0, 0);
      var status = this.props.login.error ? this.props.login.error.response.status : 200;
      this.clrErrorMsgs();
      if (status !== 200) {
        if (status === 422) {
          var err = this.props.login.error.response.data.parameters;
          var focus = true;
          for (var key in err) {
            if (err.hasOwnProperty(key)) {
              if (key !== "status") {
                this.refs["errors_" + key].innerHTML = err[key];
              }
              this.refs["errors_" + key].className = (key === "status") ? "sc-alert sc-alert-danger archive" : "input-error";
              if (key === "status") {
                this.refs["errors_" + key].parentElement.className = "notify";
              }
              if (focus && this.refs[key]) {
                focus = false;
                ReactDOM.findDOMNode(this.refs[key]).focus();
              }
            }
          }
        }
        else if (status === 401 && this.props.login.error.response.data.errors.detail) {
          this.refs.errors_credentials.parentElement.className = "notify";
          ReactDOM.findDOMNode(this.refs.email).focus();
          this.setState({ noOtherError: false, });
          this.setState({ isFormSubmitted: false, });
        }
      }
    }
  },
  clrErrorMsgs() {
    if (this.refs.errors_credentials.parentElement) { this.refs.errors_credentials.parentElement.className = "disnone"; }
    if (this.refs.errors_email.parentElement) { this.refs.errors_email.parentElement.className = ""; }
    if (this.refs.errors_email) { this.refs.errors_email.className = "disnone"; }
    if (this.refs.errors_password.parentElement) { this.refs.errors_password.parentElement.className = ""; }
    if (this.refs.errors_password) { this.refs.errors_password.className = "disnone"; }
    if (this.refs.errors_status) { this.refs.errors_status.className = "disnone"; }
    if (this.refs.errors_status) { this.refs.errors_status.parentElement.className = "disnone"; }
  },
  toggleRememberMe() {
    this.setState({
      rememberMe: !this.state.rememberMe,
    }, () => {
      if (this.state.rememberMe) {
        localStorage.setItem("rememberMe", true);
      } else {
        localStorage.setItem("rememberMe", false);
      }
    });
  },
  handleWidget(e) {
    e.preventDefault();
    window.FreshWidget.show();
  },
  render() {
    return (
      <div>
        <MobileHeaderSidenav
          isAuthenticated={false}
          isSideNavOpen={false}
        />
        <div className="page-login header-minimal-head">

          <header className="site-header header-minimal">
            <div className="container">

              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Link to='/'>
                  <img alt="icon" src={logo} style={{ height:35, width:210, margin: 25 }} />
                </Link>
              </div>

              <nav className="top-nav">
                <ul>

                </ul>
              </nav>
            </div>
          </header>
          <div className="body-wrapper signinpage">
            <section className="container login">

              <div className="login-header clearfix">
                <h1>Welcome back!</h1>
                <div className="back">
                  <Link to="/home">&#60; Back to home</Link>
                </div>
              </div>

              <div className="login-wrapper clearfix">

                <div className="left">
                  {/*Reset Password Success Message & Archived Accounts Error Message*/}
                  <div className={this.state.resetPassword ? "notify" : "disnone"}>
                    <div className={this.state.resetPassword ? "sc-alert sc-alert-success" : "disnone"}><i className="sc"></i>Email Sent!</div>
                  </div>

                  {/*Normal Log in error*/}
                  <div className="disnone">
                    <div ref="errors_credentials" className="sc-alert sc-alert-danger"><i className="sc"></i>
                      {
                    
                        (this.props.login.error && (this.props.login.error.response.data.errors.detail.includes("Invalid") || 
                        this.props.login.error.response.data.errors.detail.includes("email isn't associated"))) ? "Incorrect email address and/or password." :
                        (this.props.login.error && this.props.login.error.response.data.errors.detail.includes("Maximum Login")) ? <span>You have reached the maximum number of failed login attempts. Please <Link to='/reset-password'>reset your password.</Link></span> :
                        (this.props.login.error && this.props.login.error.response.data.errors.detail.includes("Insufficient")) ? this.props.login.error.response.data.errors.detail :
                        (this.props.login.error && this.props.login.error.response.data.errors.detail.includes("inactive")) ?
                          <span>This account has been archived. To activate it, <a onClick={this.handleWidget}>contact</a> ShippingCart Customer Care.</span> : (this.props.login.error && this.props.login.error.response.data.errors.detail.includes("You cannot register")) ? this.props.login.error.response.data.errors.detail :
                          (this.props.login.error && this.props.login.error.response.data.errors.detail.includes("Your account has been permanently suspended")) ? <span>Your account has been permanently suspended based on <Link to='/terms-conditions'>Section 4-H</Link> of our Terms of Service.</span> : this.props.login.error && this.props.login.error.response.data.errors.detail
                          
                      }
                    </div>
                  </div>

                  {
                    this.props.login.errorFB ?
                      this.props.login.errorFB.response.data.errors.detail.includes("access token") ? null :
                      <div className="sc-alert sc-alert-danger"><i className="sc"/>
                        {
                          this.props.login.errorFB.response.data.errors.detail.includes("inactive") ? 
                            <span>This account has been archived. To activate it, <a onClick={this.handleWidget}>contact</a> ShippingCart Customer Care.</span> :
                          (this.props.login.errorFB.response.data.errors.detail === "Trying to get property of non-object") ? <span>This email isn't associated with any ShippingCart account. <Link to='/signup'>Sign up.</Link></span> :
                          this.props.login.errorFB.response.data.errors.detail
                        }
                      </div>
                    : null
                  }

                  {/*Login before TYP page*/}
                  <div className={this.state.trackPackage && this.state.noOtherError ? "sc-alert sc-alert-danger" : "disnone"}><i className="sc"></i>You must login in order to access the page.</div>

                  {/*Sign In Form*/}
                  <div className="sign-in">
                    <h2>Sign in with email:</h2>
                    <div className="login-form">
                      <form id="login_form" onSubmit={this.handleSubmit}>
                        <div className="form-input">
                          <div className="input-wrapper group-input">
                            <div>
                              <label>Email address </label>&nbsp;
                              <label ref="errors_email" className="disnone"></label>
                              <input type="email" maxLength="50" className="form-control" ref="email" defaultValue={this.state.email} autoFocus />
                            </div>
                          </div>

                          <div className="input-wrapper group-input">
                            <label>Password </label>&nbsp;
                            <label ref="errors_password" className="disnone"></label>
                            <div>
                              <div className="input-group">
                                <div>
                                  <input type="password" maxLength="100" className="form-control  show-password" ref="password" defaultValue={this.state.password} />
                                </div>
                                <div className="input-group-addon">
                                  <div className="checkbox checkbox_nomargin">
                                    <input id="show_password" name="show_password" type="checkbox" ref="show_password" onClick={this.handleClick} />
                                    <label htmlFor="show_password">SHOW</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <div className="remember">
                          <div className="checkbox">
                            <input id="remember_me" type="checkbox" name="auth_remember" value="1" checked={this.state.rememberMe} onClick={this.toggleRememberMe} />
                            <label htmlFor="remember_me">Remember me</label>
                          </div>
                        </div> */}

                        <div className="submit">
                          <button type="submit" className="btn btn-login align-right btn-orange">
                            Sign in using our secure server
                                                </button>
                          <Link to="/reset-password">Forgot your password?</Link>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="center">
                  <p>or</p>
                </div>

                <div className="right">
                  {/* <div className="sc-warning" style={{ width: '270px', marginBottom: '5px', display: 'inline-flex'}}>
                    <div style={{alignSelf: 'center'}}>
                      <i
                        className="fa fa-exclamation-circle"
                        style={{ marginRight: '10px', color: '#feab10' }}
                      />
                    </div>
                    Facebook sign in is temporarily unavailable.
                  </div> */}
                  <div className="fb-login group">
                    <a className="btn-facebook clearfix" disabled>

                      <FacebookLogin socialId={fbAppId} language="en_US" fields="email" scope="public_profile,user_friends,email" responseHandler={this.responseFacebook} xfbml={true} version="v8.0" className="custombtnfacebook" buttonText="Sign in with Facebook" />

                    </a>

                    <p>Don&#8217;t have an account yet? &nbsp;
                                    <Link to="/signup">Sign up here</Link>
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <Footer
            currentPath={this.props.location.pathname}
            currentYear={this.props.login.year}
          />

        </div>
      </div>
    )
  },

});

export default SignIn;



/** WEBPACK FOOTER **
 ** ./src/components/SignIn.js
 **/